var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg08(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 83.6 127.1"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81 34.58a28.7 28.7 0 01-4.51 16 32.28 32.28 0 01-12.4 11.13 35.89 35.89 0 0114.24 11.91A30.56 30.56 0 0183.6 91.5q0 16.48-11.21 26t-30.5 9.56q-19.29 0-30.59-9.6T0 91.5a30.73 30.73 0 015.27-17.92 35.18 35.18 0 0114.19-11.9A32 32 0 017.09 50.55a29 29 0 01-4.46-16q0-15.81 10.54-25.19T41.8 0q18 0 28.59 9.3T81 34.58zM59 89.72q0-8.07-4.67-12.92T41.72 72q-7.83 0-12.49 4.8t-4.68 13q0 7.91 4.59 12.74t12.75 4.85q8 0 12.53-4.68T59 89.72zm-2.59-53.95q0-7.22-3.82-11.6T41.8 19.8q-6.88 0-10.7 4.24t-3.83 11.73q0 7.4 3.83 11.89t10.79 4.51q7 0 10.74-4.51t3.78-11.89z",
    fill: "#fff"
  })));
}
Svg08.displayName = '08';
export default Svg08;